export const HttpStatusCode = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  VALIDATION_FAILED: 422,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 505,
  ALREADY_VERIFIED: 1001,
  EXPIRED: 1002
} as const

export type HttpStatusCode = (typeof HttpStatusCode)[keyof typeof HttpStatusCode]
